<template>
  <div class="setting-main-container">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('suppliers.basic_info') }}</h3>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.display_name') }}</label>
            <p v-if="viewSupplier && viewSupplier.name !=null">{{ viewSupplier.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.primary_contact_name') }}</label>
            <p v-if="viewSupplier && viewSupplier.contact_name !=null">{{ viewSupplier.contact_name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.email') }}</label>
            <p v-if="viewSupplier && viewSupplier.email !=null">{{ viewSupplier.email }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.phone') }}</label>
            <p v-if="viewSupplier && viewSupplier.phone !=null">{{ viewSupplier.phone }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.primary_currency') }}</label>
            <p v-if="viewSupplier && viewSupplier.currency !=null">{{ viewSupplier.currency.code }}-{{ viewSupplier.currency.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.website') }}</label>
            <p v-if="viewSupplier && viewSupplier.website !=null">{{ viewSupplier.website }}</p>
          </div>


        </div>
      </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
        isLoading: false,
    }
  },
  computed: {
    ...mapGetters('supplier', [
      'viewSupplier'
    ])
  },
  created () {
    this.fetchViewSupplier(this.$route.params.id)
  },
  validations: {},
  mounted () {
  },
  methods: {
    ...mapActions('supplier', [
      'fetchViewSupplier'
    ])
  }
}
</script>
